import { Palette } from '@/themes/themeOverrides/Palette';

export const deviceConfigStyles = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    '& .device-config-toolbar': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap',
        marginBottom: '16px',
    },
    '& .device-config-select-form': {
        flex: '1 1 280px',
        maxWidth: '420px',
        margin: 0,
    },
    '& .device-config-select': {
        width: '100%',
    },
    '& .device-config-summary': {
        marginBottom: '16px',
        padding: '20px',
        borderRadius: '12px',
        backgroundColor: Palette.gray.gray75,
    },
    '& .device-config-summary-item': {
        minWidth: '140px',
        flex: 1,
    },
    '& .device-config-summary-label': {
        marginBottom: '4px',
        fontSize: '11px',
        fontWeight: 500,
    },
    '& .device-config-loading, & .device-config-empty': {
        display: 'flex',
        justifyContent: 'center',
        padding: '24px 0',
    },
    '& .device-config-table-container': {
        border: `1px solid ${Palette.gray.gray150}`,
        borderRadius: '12px',
        overflow: 'hidden',
        '& .MuiTable-root': {
            tableLayout: 'fixed',
            width: '100%',
        },
    },
    '& .MuiTableCell-root': {
        width: '33%',
        maxWidth: '33%',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
        borderColor: Palette.gray.gray150,
    },
    '& .MuiTableCell-head': {
        backgroundColor: Palette.gray.gray150,
        fontWeight: 600,
    },
    '& .MuiTableCell-body': {
        verticalAlign: 'top',
        '& .MuiTypography-root': {
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
        },
    },
    '& .device-config-row--significant .MuiTypography-root': {
        fontWeight: 700,
    },
};
